import { TUserProductAccessItem } from "@/api/services/main/customer-user/dtos/customer-user.dto";
import { EContractStatus, EProductCode, EUserProductContractStatus } from "@/types/enum";

const ACCESSIBLE_CONTRACT_STATUSES: EContractStatus[] = [EContractStatus.DURING_CONTRACT, EContractStatus.TRIAL];

export const activeProductCodes = (productAccess: TUserProductAccessItem[] = []): EProductCode[] =>
  productAccess.filter((item) => item.status === EUserProductContractStatus.ACTIVE).map((item) => item.productCode);

export const accessibleProductCodes = (productAccess: TUserProductAccessItem[] = []): EProductCode[] =>
  productAccess
    .filter((item) => item.status === EUserProductContractStatus.ACTIVE && ACCESSIBLE_CONTRACT_STATUSES.includes(item.contractStatus))
    .map((item) => item.productCode);

export const hasActiveProduct = (productAccess: TUserProductAccessItem[] = [], productCode: EProductCode): boolean =>
  activeProductCodes(productAccess).includes(productCode);
